import React from 'react';

// WebAwesome.
import WaSkeleton from '@web.awesome.me/webawesome-pro/dist/react/skeleton';

// App components.
import { SkeletonTitleBar } from 'app/client/components/OverviewSkeleton';

// Styled (reuse the real card layout so the skeleton matches the loaded card).
import * as S from '../../styled';
import * as SS from './styled';

/**
 * Loading placeholder for the user hover card: the real card chrome with an
 * avatar circle, name/username lines, badge bars and one contact row, sized
 * like a typical loaded card.
 *
 * @returns {Element} The rendered skeleton.
 */
const Skeleton = () => (
  <S.Card>
    <S.Header>
      <SS.Avatar effect="sheen" />
      <S.HeaderInfo>
        <S.Name>
          <SkeletonTitleBar width="110px" />
        </S.Name>
        <S.Username>
          <SkeletonTitleBar width="150px" />
        </S.Username>
      </S.HeaderInfo>
    </S.Header>
    <S.StatusLine>
      <WaSkeleton effect="sheen" style={{ width: '64px', height: '1.4rem' }} />
      <WaSkeleton effect="sheen" style={{ width: '56px', height: '1.4rem' }} />
    </S.StatusLine>
    <S.Separator />
    <S.ContactList>
      <S.ContactItem>
        <S.ContactIcon>
          <WaSkeleton effect="sheen" style={{ width: '14px', height: '14px' }} />
        </S.ContactIcon>
        <S.ContactValue>
          <SkeletonTitleBar width="170px" />
        </S.ContactValue>
      </S.ContactItem>
      <S.ContactItem>
        <S.ContactIcon>
          <WaSkeleton effect="sheen" style={{ width: '14px', height: '14px' }} />
        </S.ContactIcon>
        <S.ContactValue>
          <SkeletonTitleBar width="120px" />
        </S.ContactValue>
      </S.ContactItem>
    </S.ContactList>
  </S.Card>
);

export default Skeleton;
